import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";
import CustomModal from "shared/components/MDmodal/CustomModal";
import FormSchedule from "../Form/FormSchedule";
import { createScheduleService } from "modules/bitacora/services/Agendamiento/agendamientoService";

const HeaderSchedule = ({ children, onScheduleCreated }) => {
  const [open, setOpen] = useState(false);

  const handleCreate = async (data) => {
    const created = await createScheduleService(data);
    onScheduleCreated(created);
    setOpen(false);
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Agendamiento
            </MDTypography>
          </Grid>
          <Grid item>
            <MDButton
              variant="gradient"
              color="info"
              startIcon={<Icon>add</Icon>}
              onClick={() => setOpen(true)}
            >
              Crear Agendamiento
            </MDButton>
          </Grid>
        </Grid>
        {children}
      </Card>
      <CustomModal open={open} onClose={() => setOpen(false)} title="Crear Agendamiento">
        <FormSchedule onSubmit={handleCreate} afterSubmit={() => {}} />
      </CustomModal>
    </MDBox>
  );
};

HeaderSchedule.defaultProps = {
  children: "",
  onScheduleCreated: null,
};

HeaderSchedule.propTypes = {
  children: PropTypes.node,
  onScheduleCreated: PropTypes.func,
};

export default HeaderSchedule;
